import apiClient from '../utils/axios-config';
import { ContactFormData } from '../types/blog';
import { logger } from '../utils/logger';

class ContactService {
  async submitContactForm(data: ContactFormData): Promise<{ success: boolean; message: string }> {
    try {
      const response = await apiClient.post('/contact', data);
      return response.data;
    } catch (error) {
      logger.apiError('submitting contact form', error);
      throw error;
    }
  }
}

export default new ContactService();
